export default __webpack_public_path__ + "static/media/laporan-customer.8a9c7940.png";